import { ExploreResultsNonProfit } from '@Types';
import styles from './ExploreNonProfitCard.module.scss';
import { useTranslation } from 'react-i18next';
import { Link, Tile } from '@Components/common';
import { StatusChip, Tooltip } from '@Components';
import { Chip } from '@material-ui/core';

import { RiBriefcaseFill, RiMapPin2Fill, RiUserFill, RiPlayCircleFill } from 'react-icons/ri';
import { Routes } from '@App/paths';
import { OrganizationAvatar } from '@Components/OrganizationAvatar/OrganizationAvatar';

interface ExploreNonProfitCardProps {
  nonProfit: ExploreResultsNonProfit;
}

export const ExploreNonProfitCard = ({ nonProfit }: ExploreNonProfitCardProps) => {
  const { t } = useTranslation('landingPage');
  const { t: commonT } = useTranslation('common');

  return (
    <Link href={Routes.GROUP_PROFILE_PAGE(nonProfit.organization_id)} className={styles.link}>
      <Tile className={styles.tile}>
        <div className={styles.card}>
          <div className={styles.imageContainer}>
            <OrganizationAvatar avatarImage={nonProfit.image} className={styles.image} />
          </div>

          <div className={styles.projectInfo}>
            <h2>{nonProfit.name}</h2>
            <div className={styles.deliveryDetails}>
              <div className={styles.iconText}>
                <RiBriefcaseFill size={16} />
                <p>{commonT(`group_types_short.${nonProfit.type}`)}</p>
              </div>
              <div className={styles.iconText}>
                <RiMapPin2Fill size={16} />
                <p>{nonProfit.location}</p>
              </div>
            </div>

            <div className={styles.categoryList}>
              {nonProfit.categories.length > 3 ? (
                <>
                  {nonProfit.categories.slice(0, 3).map((category, i) => (
                    <StatusChip
                      className={styles.chip}
                      color="secondary"
                      label={category}
                      key={i}
                    />
                  ))}
                  <Tooltip title={nonProfit.categories.slice(3).join(' · ')}>
                    <Chip
                      className={styles.chip}
                      label={t('extra_categories', { count: nonProfit.categories.length - 3 })}
                    />
                  </Tooltip>
                </>
              ) : (
                <>
                  {nonProfit.categories.map((category, i) => (
                    <StatusChip
                      className={styles.chip}
                      color="secondary"
                      label={category}
                      key={i}
                    />
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </Tile>
    </Link>
  );
};
